import React from "react";
import { Stack, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import { attacker_color, defender_color } from "../../../theme";
import { useAbilityInfo } from "../../../valorant-api/abilities";

export function AbilityCastCard(props: {
    agent: string;
    slot: string;
    side?: string;
    timeLabel: string;
    durationLabel?: string;
    kind: "Smoke" | "Utility" | "Grenade" | "Ability" | "Ultimate";
}) {
    const ability = useAbilityInfo(props.agent, props.slot);
    const agent = props.agent || "";
    const slot = props.slot || "";
    const sideColor = props.side === "Attacker" ? attacker_color : defender_color;
    const name = ability?.name || slot.replace(/_/g, " ") || "Ability";
    const iconUrl = ability?.icon
        || `https://res.cloudinary.com/xenesis/image/upload/c_scale,h_40,w_40/v1/valAssets/${agent.replace("/", "_")}_${slot}.png`;

    return (
        <Box
            sx={{
                minWidth: 220,
                maxWidth: 280,
                background: "rgba(6, 8, 14, 0.97)",
                borderRadius: "10px",
                overflow: "hidden",
                border: `1px solid ${sideColor}50`,
                boxShadow: `0 10px 24px rgba(0,0,0,0.55), 0 0 16px ${sideColor}22`,
                pointerEvents: "none",
            }}
        >
            <Stack
                direction="row"
                alignItems="center"
                spacing={1}
                sx={{
                    px: 1.25,
                    py: 1,
                    background: `linear-gradient(135deg, ${sideColor}22 0%, transparent 75%)`,
                    borderBottom: `1px solid ${sideColor}30`,
                }}
            >
                <Box component="img" src={iconUrl} sx={{ width: 28, height: 28, objectFit: "contain" }} />
                <Box sx={{ minWidth: 0, flex: 1 }}>
                    <Typography sx={{ fontSize: "0.82rem", fontWeight: 700, color: "#fff", lineHeight: 1.2 }}>
                        {name}
                    </Typography>
                    <Typography sx={{ fontSize: "0.62rem", color: sideColor, fontWeight: 600, letterSpacing: "0.04em" }}>
                        {agent || "Unknown"} · {props.kind}
                        {props.side ? ` · ${props.side === "Attacker" ? "ATK" : "DEF"}` : ""}
                    </Typography>
                </Box>
            </Stack>
            <Box sx={{ px: 1.25, py: 1 }}>
                <Typography sx={{ fontSize: "0.62rem", color: "rgba(255,255,255,0.55)", mb: ability?.description ? 0.75 : 0 }}>
                    {props.timeLabel}{props.durationLabel ? ` · ${props.durationLabel}` : ""}
                </Typography>
                {ability?.description ? (
                    <Typography sx={{ fontSize: "0.7rem", color: "rgba(255,255,255,0.82)", lineHeight: 1.35, whiteSpace: "normal" }}>
                        {ability.description}
                    </Typography>
                ) : null}
            </Box>
        </Box>
    );
}
